export const ID = '9bc8bc94-a10b-4a72-b1cf-c17d0fbcf656';

export const NAME = 'StorageMart Move-in (Legacy)';
